unit Narocilo;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection, WEBLib.ExtCtrls, WEBLib.DB, WEBLib.DBCtrls, WEBLib.Grids, MobileForm, Vcl.Grids,
  WEBLib.CDS, System.DateUtils;

type
  TfrmNarocilo = class(TMobileForm)
    edtDatum: TDBDateTimePicker;
    btnCancel: TButton;
    cbxLokacija: TDBLookupComboBox;
    btnOk: TButton;
    edtOpombe: TMemo;
    cbxFrakcija: TDBLookupComboBox;
    wdsLokacija: TXDataWebDataSet;
    wdsFrakcija: TXDataWebDataSet;
    dsLokacija: TDataSource;
    dsFrakcija: TDataSource;
    wcdEdit: TClientDataSet;
    wcdEditLokacijaId: TIntegerField;
    wcdEditFrakcijaId: TIntegerField;
    wcdEditDatumDostave: TDateField;
    wcdEditOpombe: TStringField;
    dsEdit: TDataSource;
    procedure btnOkClick(Sender: TObject);
    procedure FormShow(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure edtOpombeDblClick(Sender: TObject);
  protected
    procedure ApplyTheme(Dark: boolean); reintroduce;
  private
    FSamoZaBranje: boolean;
    { Private declarations }
  public
    { Public declarations }
    property SamoZaBranje: boolean read FSamoZaBranje write FSamoZaBranje;
  protected procedure LoadDFMValues; override; end;

var
  frmNarocilo: TfrmNarocilo;

implementation

{$R *.dfm}

uses Main, Client.Core, Client.Settings, Auth.Service;

procedure TfrmNarocilo.btnCancelClick(Sender: TObject);
begin
  frmMain.ShowNarocila;
end;

procedure TfrmNarocilo.btnOkClick(Sender: TObject);
begin
  {$REGION 'Check podatkov'}
  if wcdEdit.FieldByName('LokacijaId').AsInteger < 1 then begin
    ShowMessage('Izberi lokacijo naročila');
    exit;
  end;

  if wcdEdit.FieldByName('FrakcijaId').AsInteger < 1 then begin
    ShowMessage('Izberi frakcijo za odvoz');
    exit;
  end;

  if wcdEdit.FieldByName('DatumDostave').AsDateTime < Today then begin
    ShowMessage('Izberi datum za odvoz');
    exit;
  end;

  {$ENDREGION}

  // Shrani nalog
  modMain.PosljiNarocilo(
    wcdEdit.FieldByName('DatumDostave').AsDateTime,
    wcdEdit.FieldByName('LokacijaId').AsInteger,
    wcdEdit.FieldByName('FrakcijaId').AsInteger,
    wcdEdit.FieldByName('Opombe').AsString
  );
end;

procedure TfrmNarocilo.edtOpombeDblClick(Sender: TObject);
begin
  ShowMessage(wcdEdit.FieldByName('LokacijaId').AsString);
end;

procedure TfrmNarocilo.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmNarocilo.FormShow(Sender: TObject);
begin
  inherited;

  ApplyTheme(AppSettings.DarkMode);
end;


procedure TfrmNarocilo.WebFormCreate(Sender: TObject);
begin
  Console.Log('Odpiranje šifrantov...');

  // Lokacije
  wdsLokacija.Close;
  wdsLokacija.QueryString := '$filter=stranka/id eq '+modMain.StrankaId.ToString;
  wdsLokacija.Load;

  // Frakcija
  wdsFrakcija.Close;
  wdsFrakcija.Load;

  // Glavni dataset
  wcdEdit.Active := true;
  wcdEdit.Append;
  wcdEdit.FieldByName('DatumDostave').AsDateTime := Today + 2;
end;

procedure TfrmNarocilo.LoadDFMValues;
begin
  inherited LoadDFMValues;

  edtDatum := TDBDateTimePicker.Create('edtDatum');
  btnCancel := TButton.Create('btnCancel');
  cbxLokacija := TDBLookupComboBox.Create('cbxLokacija');
  btnOk := TButton.Create('btnOk');
  edtOpombe := TMemo.Create('edtOpombe');
  cbxFrakcija := TDBLookupComboBox.Create('cbxFrakcija');
  wdsLokacija := TXDataWebDataSet.Create(Self);
  wdsFrakcija := TXDataWebDataSet.Create(Self);
  dsLokacija := TDataSource.Create(Self);
  dsFrakcija := TDataSource.Create(Self);
  wcdEdit := TClientDataSet.Create(Self);
  wcdEditLokacijaId := TIntegerField.Create(Self);
  wcdEditFrakcijaId := TIntegerField.Create(Self);
  wcdEditDatumDostave := TDateField.Create(Self);
  wcdEditOpombe := TStringField.Create(Self);
  dsEdit := TDataSource.Create(Self);

  edtDatum.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  cbxLokacija.BeforeLoadDFMValues;
  btnOk.BeforeLoadDFMValues;
  edtOpombe.BeforeLoadDFMValues;
  cbxFrakcija.BeforeLoadDFMValues;
  wdsLokacija.BeforeLoadDFMValues;
  wdsFrakcija.BeforeLoadDFMValues;
  dsLokacija.BeforeLoadDFMValues;
  dsFrakcija.BeforeLoadDFMValues;
  wcdEdit.BeforeLoadDFMValues;
  wcdEditLokacijaId.BeforeLoadDFMValues;
  wcdEditFrakcijaId.BeforeLoadDFMValues;
  wcdEditDatumDostave.BeforeLoadDFMValues;
  wcdEditOpombe.BeforeLoadDFMValues;
  dsEdit.BeforeLoadDFMValues;
  try
    Name := 'frmNarocilo';
    Left := 0;
    Top := 0;
    ActiveControl := cbxLokacija;
    Align := alClient;
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -27;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'FormShow');
    edtDatum.SetParentComponent(Self);
    edtDatum.Name := 'edtDatum';
    edtDatum.Left := 210;
    edtDatum.Top := 166;
    edtDatum.Width := 223;
    edtDatum.Height := 48;
    edtDatum.HeightStyle := ssAuto;
    edtDatum.WidthStyle := ssAuto;
    edtDatum.BorderStyle := bsSingle;
    edtDatum.Color := clWhite;
    edtDatum.Date := 45672.402731620370000000;
    edtDatum.ElementFont := efCSS;
    edtDatum.ElementPosition := epIgnore;
    edtDatum.Role := '';
    edtDatum.Text := '';
    edtDatum.DataField := 'DatumDostave';
    edtDatum.DataSource := dsEdit;
    btnCancel.SetParentComponent(Self);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 72;
    btnCancel.Top := 296;
    btnCancel.Width := 225;
    btnCancel.Height := 49;
    btnCancel.ChildOrder := 1;
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epIgnore;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    cbxLokacija.SetParentComponent(Self);
    cbxLokacija.Name := 'cbxLokacija';
    cbxLokacija.Left := 210;
    cbxLokacija.Top := 64;
    cbxLokacija.Width := 335;
    cbxLokacija.Height := 45;
    cbxLokacija.ElementFont := efCSS;
    cbxLokacija.ElementPosition := epIgnore;
    cbxLokacija.HeightStyle := ssAuto;
    cbxLokacija.HeightPercent := 100.000000000000000000;
    cbxLokacija.WidthStyle := ssAuto;
    cbxLokacija.WidthPercent := 100.000000000000000000;
    cbxLokacija.DataField := 'LokacijaId';
    cbxLokacija.DataSource := dsEdit;
    cbxLokacija.KeyField := 'Id';
    cbxLokacija.ListField := 'Naziv';
    cbxLokacija.ListSource := dsLokacija;
    btnOk.SetParentComponent(Self);
    btnOk.Name := 'btnOk';
    btnOk.Left := 320;
    btnOk.Top := 296;
    btnOk.Width := 225;
    btnOk.Height := 49;
    btnOk.ChildOrder := 3;
    btnOk.ElementFont := efCSS;
    btnOk.ElementPosition := epIgnore;
    btnOk.HeightStyle := ssAuto;
    btnOk.HeightPercent := 100.000000000000000000;
    btnOk.WidthStyle := ssAuto;
    btnOk.WidthPercent := 100.000000000000000000;
    SetEvent(btnOk, Self, 'OnClick', 'btnOkClick');
    edtOpombe.SetParentComponent(Self);
    edtOpombe.Name := 'edtOpombe';
    edtOpombe.Left := 210;
    edtOpombe.Top := 220;
    edtOpombe.Width := 335;
    edtOpombe.Height := 53;
    edtOpombe.ElementFont := efCSS;
    edtOpombe.ElementPosition := epIgnore;
    edtOpombe.HeightStyle := ssAuto;
    edtOpombe.HeightPercent := 100.000000000000000000;
    edtOpombe.SelLength := 0;
    edtOpombe.SelStart := 0;
    edtOpombe.WidthStyle := ssAuto;
    edtOpombe.WidthPercent := 100.000000000000000000;
    SetEvent(edtOpombe, Self, 'OnDblClick', 'edtOpombeDblClick');
    cbxFrakcija.SetParentComponent(Self);
    cbxFrakcija.Name := 'cbxFrakcija';
    cbxFrakcija.Left := 210;
    cbxFrakcija.Top := 115;
    cbxFrakcija.Width := 335;
    cbxFrakcija.Height := 45;
    cbxFrakcija.ElementFont := efCSS;
    cbxFrakcija.ElementPosition := epIgnore;
    cbxFrakcija.HeightStyle := ssAuto;
    cbxFrakcija.HeightPercent := 100.000000000000000000;
    cbxFrakcija.WidthStyle := ssAuto;
    cbxFrakcija.WidthPercent := 100.000000000000000000;
    cbxFrakcija.DataField := 'FrakcijaId';
    cbxFrakcija.DataSource := dsEdit;
    cbxFrakcija.KeyField := 'Id';
    cbxFrakcija.ListField := 'Opis';
    cbxFrakcija.ListSource := dsFrakcija;
    wdsLokacija.SetParentComponent(Self);
    wdsLokacija.Name := 'wdsLokacija';
    wdsLokacija.EntitySetName := 'Lokacija';
    wdsLokacija.Connection := modMain.connServer;
    wdsLokacija.Left := 88;
    wdsLokacija.Top := 24;
    wdsFrakcija.SetParentComponent(Self);
    wdsFrakcija.Name := 'wdsFrakcija';
    wdsFrakcija.EntitySetName := 'Frakcija';
    wdsFrakcija.Connection := modMain.connServer;
    wdsFrakcija.SubpropsDepth := 1;
    wdsFrakcija.Left := 160;
    wdsFrakcija.Top := 24;
    dsLokacija.SetParentComponent(Self);
    dsLokacija.Name := 'dsLokacija';
    dsLokacija.DataSet := wdsLokacija;
    dsLokacija.Left := 88;
    dsLokacija.Top := 80;
    dsFrakcija.SetParentComponent(Self);
    dsFrakcija.Name := 'dsFrakcija';
    dsFrakcija.DataSet := wdsFrakcija;
    dsFrakcija.Left := 160;
    dsFrakcija.Top := 80;
    wcdEdit.SetParentComponent(Self);
    wcdEdit.Name := 'wcdEdit';
    wcdEdit.Active := True;
    wcdEdit.Left := 15;
    wcdEdit.Top := 24;
    wcdEditLokacijaId.SetParentComponent(wcdEdit);
    wcdEditLokacijaId.Name := 'wcdEditLokacijaId';
    wcdEditLokacijaId.FieldName := 'LokacijaId';
    wcdEditFrakcijaId.SetParentComponent(wcdEdit);
    wcdEditFrakcijaId.Name := 'wcdEditFrakcijaId';
    wcdEditFrakcijaId.FieldName := 'FrakcijaId';
    wcdEditDatumDostave.SetParentComponent(wcdEdit);
    wcdEditDatumDostave.Name := 'wcdEditDatumDostave';
    wcdEditDatumDostave.FieldName := 'DatumDostave';
    wcdEditOpombe.SetParentComponent(wcdEdit);
    wcdEditOpombe.Name := 'wcdEditOpombe';
    wcdEditOpombe.FieldName := 'Opombe';
    wcdEditOpombe.Size := 50;
    dsEdit.SetParentComponent(Self);
    dsEdit.Name := 'dsEdit';
    dsEdit.DataSet := wcdEdit;
    dsEdit.Left := 16;
    dsEdit.Top := 80;
  finally
    edtDatum.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    cbxLokacija.AfterLoadDFMValues;
    btnOk.AfterLoadDFMValues;
    edtOpombe.AfterLoadDFMValues;
    cbxFrakcija.AfterLoadDFMValues;
    wdsLokacija.AfterLoadDFMValues;
    wdsFrakcija.AfterLoadDFMValues;
    dsLokacija.AfterLoadDFMValues;
    dsFrakcija.AfterLoadDFMValues;
    wcdEdit.AfterLoadDFMValues;
    wcdEditLokacijaId.AfterLoadDFMValues;
    wcdEditFrakcijaId.AfterLoadDFMValues;
    wcdEditDatumDostave.AfterLoadDFMValues;
    wcdEditOpombe.AfterLoadDFMValues;
    dsEdit.AfterLoadDFMValues;
  end;
end;

end.
